import React from 'react';
import UserAuthAvatar from '../UserAuthAvatar';
import { Logo } from '../Logo';
import { useSidebar } from 'contexts/SidebarContext';

export const Header: React.FC = () => {
  const { isMobile, setMobileOpen } = useSidebar();

  return (
    <header className="h-[64px] bg-card border-b border-border flex items-center justify-between px-4 md:justify-end md:px-6">
      {isMobile && (
        <div className="flex items-center gap-3">
          <button
            onClick={() => setMobileOpen(true)}
            className="p-2 rounded hover:bg-surface transition-colors"
            aria-label="Open menu"
          >
            <svg className="w-5 h-5 text-text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <Logo variant="small" />
        </div>
      )}
      <div className="flex items-center space-x-4">
        <UserAuthAvatar />
      </div>
    </header>
  );
};
